module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "ui segment"
  }, ["\n  User: " + _vm._s(_vm.$route.params.id) + "\n  ", (_vm.data) ? _vm._h('ProfileDetail', {
    attrs: {
      "profile": _vm.data
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57a32870!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = 242
// module chunks = 2